module.exports = __webpack_public_path__ + "static/media/alteryx.a1959757.png";